import React from 'react'
import FormControl from '@mui/material/FormControl'
import Grid from '@mui/material/Grid'
import InputLabel from '@mui/material/InputLabel'
import MenuItem from '@mui/material/MenuItem'
import Select from '@mui/material/Select'

const Indication = ({ moduleValues, setModuleValues }) => (
  <Grid item xs={12}>
    <FormControl fullWidth>
      <InputLabel>Indication</InputLabel>
      <Select
        value={moduleValues?.['Indication'] ?? ''}
        label="Indication"
        onChange={(e) =>
          setModuleValues((prev) => ({
            ...prev,
            ['Indication']: e.target.value,
          }))
        }
      >
        {[
          'Agitation (e.g. acute behavioural disturbance)',
          'Pain relief (inadequate response to standard analgesia)',
          'Procedural (e.g. dislocation, fracture manipulation)',
          'Seizure management',
          'Facilitated intubation',
          'Post-cardiac arrest care',
          'Emergence phenomenon requiring re-sedation',
          'Other',
        ].map((x, index) => (
          <MenuItem key={index} value={x}>
            {x}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  </Grid>
)

export default Indication
